import { FETCH_START, FETCH_SUCCESS, FETCH_ERROR, SET_USER_ROLES, SET_USER_ROLE, CHANGE_USER_ROLES_TAB, SHOW_MESSAGE, HIDE_MESSAGE, NEW_USER_ROLE } from "constants/ActionTypes";
import axios from 'util/Api'

export const getUserRolesList = () => async dispatch => {
  try {
    dispatch({ type: FETCH_START });
    const res = await axios.get('api/userRoles/list');
    dispatch({ type: FETCH_SUCCESS });
    dispatch({ type: SET_USER_ROLES, payload: res.data });
  } catch (err) {
    const errors = err.response?.data.errors;
    if (errors) {
      errors.forEach(error => dispatch({ type: FETCH_ERROR, payload: error.msg }));
      dispatch({ type: HIDE_MESSAGE });
    } else {
      console.log("Error****:", err);
    }
  };
};

export const createUserRole = (userRoleData) => async dispatch => {
  console.log('userRoleData: Dispatch', userRoleData);
  try {
    dispatch({ type: FETCH_START });
    const res = await axios.put('api/userRoles/add', userRoleData);
    dispatch({ type: FETCH_SUCCESS });
    dispatch({ type: SHOW_MESSAGE, payload: 'User Role saved' });
    dispatch({ type: HIDE_MESSAGE });
    dispatch({ type: CHANGE_USER_ROLES_TAB, payload: { value: 0 } });
  } catch (err) {
    const errors = err.response.data.errors;
    console.log(err.response)
    if (errors) {
      errors.forEach(error => dispatch({ type: FETCH_ERROR, payload: error.msg }));
      dispatch({ type: HIDE_MESSAGE });
    } else {
      console.log("Error****:", err);
    }
  };
};


export const updateUserRole = (userRoleData) => async dispatch => {
  console.log('userRoleData: Dispatch', userRoleData);
  try {
    dispatch({ type: FETCH_START });
    const res = await axios.put('api/userRoles/edit', userRoleData);
    dispatch({ type: FETCH_SUCCESS });
    dispatch({ type: SHOW_MESSAGE, payload: 'User Role saved' });
    dispatch({ type: HIDE_MESSAGE });
    dispatch({ type: CHANGE_USER_ROLES_TAB, payload: { value: 0 } });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => dispatch({ type: FETCH_ERROR, payload: error.msg }));
      dispatch({ type: HIDE_MESSAGE });
    } else {
      console.log("Error****:", err);
    }
  };
};

export const deleteUserRole = (userRole) => async dispatch => {
  try {
    dispatch({ type: FETCH_START });
    const res = await axios.delete(`api/userRoles/remove/${userRole._id}`);
    dispatch({ type: FETCH_SUCCESS });
    dispatch({ type: SHOW_MESSAGE, payload: 'User Role deleted!' });
    dispatch({ type: HIDE_MESSAGE });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => dispatch({ type: FETCH_ERROR, payload: error.msg }));
      dispatch({ type: HIDE_MESSAGE });
    } else {
      console.log("Error****:", err);
    }
  };
};

export const setNewUserRoleStatus = (status) => {
  return {
    type: NEW_USER_ROLE,
    payload: status
  }
};

export const setUserRolesList = (userRolesList) => {
  return {
    type: SET_USER_ROLES,
    payload: userRolesList
  }
};

export const setUserRole = (userRole) => {
  console.log(userRole)
  return {
    type: SET_USER_ROLE,
    payload: userRole
  }
};

export const changeUserRolesTab = (tabValue) => {
  return {
    type: CHANGE_USER_ROLES_TAB,
    payload: tabValue
  }
};